export enum PackagingSelectionVariant {
  PDP,
  SRP,
  Campaign,
}
